(() => {
  'use strict';
  const readStrings = root => JSON.parse(root.querySelector('[data-tool-strings]').textContent);
  const field = (form, name) => form.elements.namedItem(name);
  const money = new Intl.NumberFormat(document.documentElement.lang.startsWith('ms') ? 'ms-MY' : 'en-MY', { style: 'currency', currency: 'MYR' });
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const keys = ['people', 'nights', 'days', 'room', 'transport', 'activities', 'meals', 'flights', 'other', 'buffer'];
  const costKeys = ['room', 'transport', 'activities', 'meals', 'flights', 'other'];
  const shortKeys = ['p', 'n', 'd', 'r', 't', 'a', 'm', 'f', 'o', 'b'];
  const compute = value => {
    const detail = { lodging: value.room * value.nights, transport: value.transport, activities: value.activities * value.people, meals: value.meals * value.days * value.people, flights: value.flights * value.people, other: value.other };
    const subtotal = Object.values(detail).reduce((sum, amount) => sum + Math.round((amount + Number.EPSILON) * 100), 0);
    const bufferCents = Math.floor((subtotal * Math.round(value.buffer * 100) + 5000) / 10000);
    detail.buffer = bufferCents / 100;
    const total = (subtotal + bufferCents) / 100;
    return { detail, total, person: total / value.people };
  };
  document.querySelectorAll('[data-budget-tool]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const strings = readStrings(root);
    const form = root.querySelector('form');
    const error = root.querySelector('#budget-error');
    const status = root.querySelector('[data-budget-status]');
    const shareStatus = root.querySelector('[data-share-status]');
    const share = root.querySelector('.jv-budget__share');
    const linkField = root.querySelector('#budget-share-link');
    const create = root.querySelector('[data-create-link]');
    const total = root.querySelector('#budget-total');
    const person = root.querySelector('#budget-person');
    let current = null;
    let timer;
    function invalidateLink() {
      share.hidden = true;
      linkField.value = '';
      shareStatus.textContent = '';
    }
    function update() {
      const values = {};
      let invalid = false;
      keys.forEach(name => {
        const input = field(form, name);
        const number = Number(input.value);
        const required = ['people', 'nights', 'days'].includes(name);
        const valid = (!required || input.value.trim() !== '') && Number.isFinite(number) && input.validity.valid;
        input.setAttribute('aria-invalid', String(!valid));
        input.setAttribute('aria-describedby', (input.dataset.originalDescription || '') + (!valid ? ' budget-error' : ''));
        invalid ||= !valid;
        values[name] = number;
      });
      const durationInvalid = !invalid && values.days < values.nights;
      if (durationInvalid) {
        ['days', 'nights'].forEach(name => { field(form, name).setAttribute('aria-invalid', 'true'); field(form, name).setAttribute('aria-describedby', 'budget-error'); });
      }
      invalid ||= durationInvalid;
      error.textContent = invalid ? strings[durationInvalid ? 'duration_error' : 'invalid'] : '';
      error.hidden = !invalid;
      const hasCosts = costKeys.some(name => values[name] > 0);
      root.querySelectorAll('[data-people]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.people) === values.people)));
      create.disabled = invalid || !hasCosts;
      root.querySelector('[data-budget-empty]').hidden = invalid || hasCosts;
      root.querySelector('.jv-budget__breakdown').hidden = invalid || !hasCosts;
      current = invalid ? null : values;
      if (invalid || !hasCosts) { total.textContent = '—'; person.textContent = '—'; return; }
      const result = compute(values);
      total.textContent = money.format(result.total);
      person.textContent = money.format(result.person);
      root.querySelectorAll('[data-cost]').forEach(item => item.textContent = money.format(result.detail[item.dataset.cost]));
    }
    keys.forEach(name => { const input = field(form, name); input.dataset.originalDescription = input.getAttribute('aria-describedby') || ''; });
    root.querySelectorAll('[data-people]').forEach(button => button.addEventListener('click', () => {
      field(form, 'people').value = button.dataset.people;
      invalidateLink();
      update();
      status.textContent = strings.preset_status;
    }));
    form.addEventListener('submit', event => { event.preventDefault(); clearTimeout(timer); update(); if (current === null) form.querySelector('[aria-invalid=true]')?.focus(); });
    form.addEventListener('input', event => {
      if (!keys.includes(event.target.name)) return;
      invalidateLink();
      status.textContent = '';
      create.disabled = true;
      clearTimeout(timer);
      timer = setTimeout(update, 180);
    });
    form.addEventListener('reset', () => {
      clearTimeout(timer);
      setTimeout(() => {
        invalidateLink();
        update();
        status.textContent = strings.reset_status;
        if (location.hash.startsWith('#jb=')) history.replaceState(null, '', location.pathname + location.search + '#budget-calculator');
      }, 0);
    });
    create.addEventListener('click', () => {
      clearTimeout(timer);
      update();
      if (!current || create.disabled) return;
      const params = new URLSearchParams({ jb: '1' });
      keys.forEach((name, i) => params.set(shortKeys[i], String(current[name])));
      const canonical = document.querySelector('link[rel="canonical"]')?.href || location.origin + location.pathname;
      const url = new URL(canonical, location.origin);
      url.search = '';
      url.hash = params.toString();
      linkField.value = url.href;
      share.hidden = false;
      shareStatus.textContent = strings.created;
      linkField.focus();
      linkField.select();
    });
    root.querySelector('[data-copy-link]').addEventListener('click', async () => {
      if (!linkField.value) return;
      try { await navigator.clipboard.writeText(linkField.value); shareStatus.textContent = strings.copied; }
      catch { shareStatus.textContent = strings.manual; linkField.focus(); linkField.select(); }
    });
    function restoreFromHash() {
      if (!location.hash.startsWith('#jb=')) return;
      clearTimeout(timer);
      invalidateLink();
      keys.forEach(name => { field(form, name).value = field(form, name).defaultValue; });
      const hash = location.hash.slice(1);
      const params = new URLSearchParams(hash);
      const allowed = ['jb', ...shortKeys];
      const entries = [...params.entries()];
      const validLink = hash.length <= 500 && params.get('jb') === '1' && entries.every(([key]) => allowed.includes(key)) && new Set(entries.map(([key]) => key)).size === entries.length && shortKeys.slice(0, 3).every(key => params.has(key)) && entries.every(([key, value]) => key === 'jb' || /^\d+(\.\d{1,2})?$/.test(value));
      if (validLink) {
        keys.forEach((name, i) => { if (params.has(shortKeys[i])) field(form, name).value = params.get(shortKeys[i]); });
        update();
        if (current) {
          status.textContent = strings.restored;
          root.querySelector('.jv-tool__details').open = ['flights', 'other', 'buffer'].some(name => current[name] > 0);
          requestAnimationFrame(() => root.scrollIntoView({ behavior: 'auto', block: 'start' }));
          return;
        }
      }
      keys.forEach(name => { field(form, name).value = field(form, name).defaultValue; });
      update();
      status.textContent = strings.invalid_link;
    }
    form.hidden = false;
    update();
    restoreFromHash();
    addEventListener('hashchange', restoreFromHash);
  });
  document.querySelectorAll('[data-trip-planner]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const strings = readStrings(root);
    const form = root.querySelector('form');
    const result = root.querySelector('[data-planner-results]');
    const error = root.querySelector('[data-planner-error]');
    const status = root.querySelector('[data-planner-status]');
    const budget = root.querySelector('[data-planner-budget]');
    const budgetBase = budget.href;
    const substitute = (text, values) => text.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
    field(form, 'party').addEventListener('change', () => {
      const presets = { solo: 1, couple: 2, family: 4 };
      if (presets[field(form, 'party').value]) field(form, 'people').value = presets[field(form, 'party').value];
    });
    form.addEventListener('input', () => { result.hidden = true; status.textContent = ''; });
    form.addEventListener('change', () => { result.hidden = true; status.textContent = ''; });
    form.addEventListener('submit', event => {
      event.preventDefault();
      let invalid = false;
      ['destination', 'nights', 'people'].forEach(name => {
        const input = field(form, name);
        const valid = input.value !== '' && input.validity.valid;
        input.setAttribute('aria-invalid', String(!valid));
        if (!valid) input.setAttribute('aria-describedby', 'planner-error');
        else input.removeAttribute('aria-describedby');
        invalid ||= !valid;
      });
      const destination = field(form, 'destination').value;
      const template = [...root.querySelectorAll('template[data-plan]')].find(item => item.dataset.plan === destination);
      invalid ||= !template;
      error.textContent = invalid ? strings.invalid : '';
      error.hidden = !invalid;
      if (invalid) { result.hidden = true; form.querySelector('[aria-invalid=true]')?.focus(); return; }
      const nights = Number(field(form, 'nights').value);
      const people = Number(field(form, 'people').value);
      const family = field(form, 'party').value === 'family';
      const title = root.querySelector('[data-planner-heading]');
      title.textContent = substitute(strings.result_title, { destination: field(form, 'destination').selectedOptions[0].textContent });
      root.querySelector('[data-planner-summary]').textContent = substitute(strings[people === 1 ? 'one_summary' : 'summary'], { nights, people });
      root.querySelector('[data-planner-pace]').textContent = strings[nights === 1 ? 'short' : nights <= 4 ? 'medium' : 'long'];
      root.querySelector('[data-planner-family]').hidden = !family;
      root.querySelector('[data-planner-island]').hidden = !['langkawi', 'semporna'].includes(destination);
      const links = root.querySelector('[data-planner-links]');
      links.replaceChildren(template.content.cloneNode(true));
      links.querySelectorAll('[data-family-guide]').forEach(item => item.hidden = !family);
      const url = new URL(budgetBase, location.origin);
      url.hash = new URLSearchParams({ jb: '1', p: String(people), n: String(nights), d: String(nights + 1) }).toString();
      budget.href = url.href;
      result.hidden = false;
      status.textContent = strings.ready;
      title.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'nearest' });
    });
    form.hidden = false;
  });
})();
